import React from 'react';
import NavTagline from '../nav-tagline/nav-tagline';
import Footer from './Footer';


const RequestNotFound = () => (
    <div className="RequestNotFound">
        <NavTagline />
        <section className="layout-container">
            <div className="container ctr">
                <div className="text-size3 or-clr"><i class="bi bi-cone-striped"></i></div>
                <div className="text-size4">Sorry, your request was not found.</div>
                <div className="text-size9"><p>The page you are looking for does not exist. </p> If you need immediate support, please call 1.888.470.9913 or email us at <a href="mailto: support@secureexsolutions.com">support@secureexsolutions.com</a>.</div>
            </div>
        </section>
        <Footer />
  </div>
);


export default RequestNotFound;
